// extracted by mini-css-extract-plugin
module.exports = {"checkboxInputRow":"k_n5","checkboxInputColumn":"k_n6","inputOptionRow":"k_nL","inputOptionColumn":"k_nM"};